import React, { useState } from 'react';
import './VIPClub.css';
import BottomNav from "../../components/BottomNav/BottomNav";
import InnerHeader from "../../components/InnerHeader";
import Header from "../../components/Header/Header";
import Sponsorships from '../../components/SponsorshipSection/SponsorshipSection';
const VIPDetails = () => {
  const [currentTier, setCurrentTier] = useState(2); // Expert tier

  const tiers = [
    { id: 0, name: 'ELITE', color: '#94A3B8', icon: '🥉' },
    { id: 1, name: 'PRO', color: '#9CA3AF', icon: '🥈' },
    { id: 2, name: 'EXPERT', color: '#EAB308', icon: '🥇' }
  ];

  const tableData = [
    { product: 'Slots', turnover: 1, vp: 1.4 },
    { product: 'Fishing', turnover: 1, vp: 1.4 },
    { product: 'Crash', turnover: 1, vp: 1.4 },
    { product: 'Lottery', turnover: 1, vp: 1.1 },
    { product: 'Table Games', turnover: 1, vp: 0.9 },
    { product: 'Live Casino', turnover: 1, vp: 0.5 },
    { product: 'P2P', turnover: 1, vp: 0.4 },
    { product: 'Arcade', turnover: 1, vp: 0.4 }
  ];
  const rewards = [
    { label: 'VIP Points To Cash', points: '180', coins: '1', active: true },
    { label: 'VIP Level Up Reward', active: true },
    { label: 'VIP Payment Channel', active: false },
    { label: '24/7 Personal VIP Manager', active: false },
    { label: 'VIP Birthday Reward', active: false },
    { label: 'VIP Loyalty Bonus', active: false },
    { label: 'VIP Exclusive Bonus', active: false },
    { label: 'VIP Exclusive Reward', active: false },
    { label: 'VIP Exclusive Gift', active: false }
  ];

  const scrollTiers = (direction) => {
    if (direction === 'left' && currentTier > 0) {
      setCurrentTier(currentTier - 1);
    } else if (direction === 'right' && currentTier < tiers.length - 1) {
      setCurrentTier(currentTier + 1);
    }
  };

  return (
    <>
      <Header />
      <InnerHeader title="VIP Details" />
      
      <div className="vip-details-container">
        {/* Hero Banner */}
        <div className="vip-hero-banner">
          {/* Decorative elements */}
          <div className="vip-decorative-element vip-decorative-element-1"></div>
          <div className="vip-decorative-element vip-decorative-element-2"></div>
          <div className="vip-decorative-element vip-decorative-element-3"></div>

          {/* Crown */}
          <div className="vip-crown-container">
            <div className="vip-crown">👑</div>
            {/* Coin decoration */}
            <div className="vip-coin-decoration">💰</div>
          </div>

          {/* Title and Description */}
          <div className="vip-hero-content">
            <h2 className="vip-hero-title">WHY BAJI VIP CLUB?</h2>
            <p className="vip-hero-description">
              The Baji VIP Club enriches your betting experience with a priority payment lane and 24/7 personalised VIP manager exclusive to <span className="vip-highlight-text">Baji VIP</span> only. Join the Baji VIP Club today to unlock all levels of excitement with big prizes and cash!
            </p>
          </div>
        </div>

        {/* Tier Selector */}
        <div className="vip-tier-selector">
        <div >
          {/* Navigation Arrows */}
          <button
            onClick={() => scrollTiers('left')}
            disabled={currentTier === 0}
            className="vip-nav-arrow vip-nav-arrow-left"
          >
            ‹
          </button>

          <button
            onClick={() => scrollTiers('right')}
            disabled={currentTier === tiers.length - 1}
            className="vip-nav-arrow vip-nav-arrow-right"
          >
            ›
          </button>

          {/* Tier Cards */}
          <div className="vip-tier-cards">
            {tiers.map((tier, index) => (
              <div
                key={tier.id}
                onClick={() => setCurrentTier(index)}
                className={`vip-tier-card ${currentTier === index ? 'active' : ''}`}
              >
                <div 
                  className="vip-tier-icon"
                  style={{ background: tier.color }}
                >
                  {tier.icon}
                </div>
                <span className="vip-tier-name">{tier.name}</span>
              </div>
            ))}
          </div>

          {/* Current Tier Info */}
          <div className="vip-current-tier">
            <div className="vip-current-tier-icon">
              {tiers[currentTier].icon}
            </div>
            <div className="vip-current-tier-info">
              <h3 className="vip-current-tier-title">
                {tiers[currentTier].name} I - III
              </h3>
              <div className="vip-current-tier-points">
                24,00,000 VE
              </div>
            </div>
          </div>
        </div>

        {/* Rewards Section */}
        <div className="vip-rewards-section">
          <h3 className="vip-rewards-title">YOUR REWARDS & BENEFITS</h3>

          <div className="vip-rewards-list">
            {rewards.map((reward, index) => (
              <div
                key={index}
                className={`vip-reward-item ${reward.active ? 'active' : ''}`}
              >
                <div className={`vip-reward-checkbox ${reward.active ? 'active' : ''}`}>
                  {reward.active && <span className="vip-reward-checkmark">✓</span>}
                </div>
                <span className="vip-reward-label">{reward.label}</span>
                {reward.points && (
                  <div className="vip-reward-conversion">
                    <div className="vip-reward-points-badge">
                      <span>💎</span>
                      <span>{reward.points}</span>
                      <span>▶</span>
                    </div>
                    <div className="vip-reward-coins-badge">
                      <span>💰</span>
                      <span>{reward.coins}</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

        
        </div>
        <button className="vip-learn-more-btn">
            LEARN MORE
          </button>
        </div>


           <div className="vip-points-table-wrapper">
      <div className="vip-points-table-container">
        <h2 className="vip-rewards-title">
          How to Earn VIP Points (VP)
        </h2>

        <div className="vip-points-table-header">
          <div className="vip-points-table-header-cell">
            Product Type
          </div>
          <div className="vip-points-table-header-cell">
            Effective<br />Turnover<br />(BDT)
          </div>
          <div className="vip-points-table-header-cell">
            VIP Points<br />(VP)
          </div>
        </div>

        <div className="vip-points-table-body">
          {tableData.map((row, index) => (
            <div key={index} className="vip-points-table-row">
              <div className="vip-points-table-product">
                {row.product}
              </div>
              <div className="vip-points-table-badge turnover">
                <div className="vip-points-table-icon bdt">৳</div>
                <span>{row.turnover}</span>
              </div>
              <div className="vip-points-table-badge vp">
                <div className="vip-points-table-icon vp">VP</div>
                <span>{row.vp}</span>
              </div>
            </div>
          ))}
        </div>

        <button className="vip-learn-more-btn">
            LEARN MORE
          </button>
      </div>
    </div>
  
      </div>
      
      <Sponsorships />
      <BottomNav />
    </>
  );
};

export default VIPDetails;